import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/landingpage.js';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ArticleEditor from './pages/admin/ArticleEditor';
import ArticlePreview from './pages/admin/ArticlePreview';
import ProtectedRoute from './components/ProtectedRoute';
import ArticlesPage from './pages/public/ArticlesPage';
import ArticleDetail from './pages/public/ArticleDetail';
import PublicationUploader from './pages/admin/PublicationUploader';
import PublicationsPage from './pages/public/PublicationPage';
import CookieConsent from './components/CookieConsent';
import './App.css';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/spc-portal-1003/login" element={<AdminLogin />} />
          <Route path="/spc-portal-1003" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/spc-portal-1003/articles/new" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
          <Route path="/spc-portal-1003/articles/:id/edit" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
          <Route path="/spc-portal-1003/articles/:id/preview" element={<ProtectedRoute><ArticlePreview /></ProtectedRoute>} />
          <Route path="/spc-portal-1003/publications" element={<ProtectedRoute><PublicationUploader /></ProtectedRoute>} />
          <Route path="/publications" element={<PublicationsPage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />
        </Routes>
      </Router>
      <CookieConsent />
    </>
  );
}
export default App;